import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { IRule } from "../../../types";
import { RuleConstraint } from "../types";

interface RulesContextProps {
    children: React.ReactNode,
    constraints: RuleConstraint[],
    setConstraints: Dispatch<SetStateAction<RuleConstraint[]>>,
    rule?: IRule
}

interface IContextValue {
    constraints: RuleConstraint[],
    setConstraints?: Dispatch<SetStateAction<RuleConstraint[]>>,
    rule?: IRule
}

const RulesContext = createContext<IContextValue>({
    constraints: []
});

export const useRulesContext = () => {
    return useContext(RulesContext);
};

export const RulesProvider = ({
    constraints,
    setConstraints,
    rule,
    children,
}: RulesContextProps) => {

    return (
        <RulesContext.Provider value={{
            constraints,
            setConstraints,
            rule
        }}>
            {children}
        </RulesContext.Provider >
    )
};

export default RulesContext;